import {Stack} from '@mui/material';
import {Filter} from 'presentation/components/Filter';
import React from 'react';
import {FilterDrawer} from '../FilterDrawer';
import {MyHospitalizationFilterHeaderType} from './types';

export const MyHospitalizationFilterHeader = ({
	searchProps,
	showFilterDrawer,
	titleListDrawer,
	listDrawerItens,
}: MyHospitalizationFilterHeaderType) => (
	<Filter.Root>
		<Stack direction={'row'} gap={1}>
			<Filter.Search {...searchProps} />
			{showFilterDrawer ? (
				<FilterDrawer listDrawerItens={listDrawerItens} titleListDrawer={titleListDrawer} />
			) : null}
		</Stack>
	</Filter.Root>
);
